import {
  n,
  r
} from "./chunk.QXWAL3TN.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/mixins/FormElement.ts
function FormElement(baseClass) {
  class FormElementMixin extends baseClass {
    constructor() {
      super(...arguments);
      this.disabled = false;
      this.errorText = "";
      this.frontendRenderingIdentifier = "";
      this.label = "";
      this.requiredText = "";
      this.showError = false;
      this.value = "";
    }
    connectedCallback() {
      super.connectedCallback();
      this.populateValue();
    }
    updated(changedProperties) {
      super.updated(changedProperties);
      const newValues = /* @__PURE__ */ new Map();
      changedProperties.forEach((_oldValue, key) => {
        newValues.set(key, this[key]);
      });
      this.dispatchEvent(
        new CustomEvent("field-update", {
          bubbles: true,
          detail: { field: this, changedProperties, newValues }
        })
      );
    }
    appendFormData(formDataEvent) {
      formDataEvent.formData.append(this.name, this.value || "");
    }
    populateValue() {
      if (this.frontendRenderingIdentifier) {
        let storedData = localStorage.getItem("savedFormData");
        if (storedData === null) {
          return;
        }
        storedData = JSON.parse(storedData);
        if (this.frontendRenderingIdentifier && this.frontendRenderingIdentifier in storedData) {
          this.value = storedData[this.frontendRenderingIdentifier];
        }
      }
    }
    validate() {
      const valid = this.disabled || (this.requiredText ? !!this.value : true);
      this.showError = !valid;
      this.errorText = "";
      return valid;
    }
  }
  __decorateClass([
    n({ type: Boolean })
  ], FormElementMixin.prototype, "disabled", 2);
  __decorateClass([
    n()
  ], FormElementMixin.prototype, "errorText", 2);
  __decorateClass([
    n()
  ], FormElementMixin.prototype, "frontendRenderingIdentifier", 2);
  __decorateClass([
    n()
  ], FormElementMixin.prototype, "label", 2);
  __decorateClass([
    n()
  ], FormElementMixin.prototype, "name", 2);
  __decorateClass([
    n()
  ], FormElementMixin.prototype, "requiredText", 2);
  __decorateClass([
    r()
  ], FormElementMixin.prototype, "showError", 2);
  __decorateClass([
    n()
  ], FormElementMixin.prototype, "value", 2);
  return FormElementMixin;
}

export {
  FormElement
};
